export default __webpack_public_path__ + "static/media/rainworld.2821e2d4.png";